module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/schools/tpl.html
// module id = 1209
// module chunks = 0